module.exports = __webpack_public_path__ + "img/spiral-details15.291faf4f.png";